<template>
  <div class="input-group input-group-outline m-0 d-flex flex-column position-relative">
    <label class="input-label justify-content-start text-start w-100">
      <span class="text-xs text-uppercase text-body font-weight-bolder">
        {{ label }}
      </span>
      <div class="d-flex align-items-center position-relative">
        <input
          :value="modelValue"
          :type="type"
          class="form-control default-bordered-input"
          :placeholder="placeholder"
          :disabled="disabled"
          :readonly="readonly"
          @input="handleInput($event.target.value)"
        />
        <button 
          v-if="showAppendButton" 
          class="append-button" 
          @click="$emit('append-click')"
        >
          <i class="material-icons icon">{{ appendIcon }}</i>
        </button>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'DefaultInput',
  props: {
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: String,
      required: true,
    },
    showAppendButton: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
      default: "plus",
    },
  },
  methods: {
    handleInput(value) {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<style scoped lang="scss">
.append-button {
  background: transparent;
  border: none;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
}

.append-button .icon {
  transition: transform 0.1s;
}

.append-button:hover .icon {
  transform: scale(1.2);
}
</style>
